
			[data-rs-theme="gintoTheme"] {
					--rs-font-family-title: Inter, BlinkMacSystemFont, -apple-system, Roboto, Helvetica, Arial, sans-serif;
--rs-font-family-body: Inter, BlinkMacSystemFont, -apple-system, Roboto, Helvetica, Arial, sans-serif;
--rs-font-weight-regular: 400;
--rs-font-weight-medium: 500;
--rs-font-weight-semibold: 600;
--rs-font-weight-bold: 700;
--rs-font-weight-extrabold: 800;
--rs-font-weight-black: 900;
--rs-font-size-title-1: 6rem;
--rs-line-height-title-1: 6.25rem;
--rs-font-family-title-1: var(--rs-font-family-title);
--rs-font-weight-title-1: var(--rs-font-weight-extrabold);
--rs-letter-spacing-title-1: normal;
--rs-font-size-title-2: 5rem;
--rs-line-height-title-2: 5.25rem;
--rs-font-family-title-2: var(--rs-font-family-title);
--rs-font-weight-title-2: var(--rs-font-weight-extrabold);
--rs-letter-spacing-title-2: normal;
--rs-font-size-title-3: 4rem;
--rs-line-height-title-3: 4.25rem;
--rs-font-family-title-3: var(--rs-font-family-title);
--rs-font-weight-title-3: var(--rs-font-weight-extrabold);
--rs-letter-spacing-title-3: normal;
--rs-font-size-title-4: 3.5rem;
--rs-line-height-title-4: 3.75rem;
--rs-font-family-title-4: var(--rs-font-family-title);
--rs-font-weight-title-4: var(--rs-font-weight-bold);
--rs-letter-spacing-title-4: normal;
--rs-font-size-title-5: 3rem;
--rs-line-height-title-5: 3.25rem;
--rs-font-family-title-5: var(--rs-font-family-title);
--rs-font-weight-title-5: var(--rs-font-weight-bold);
--rs-letter-spacing-title-5: normal;
--rs-font-size-title-6: 2.25rem;
--rs-line-height-title-6: 2.5rem;
--rs-font-family-title-6: var(--rs-font-family-title);
--rs-font-weight-title-6: var(--rs-font-weight-bold);
--rs-letter-spacing-title-6: normal;
--rs-font-size-featured-1: 2rem;
--rs-line-height-featured-1: 2.5rem;
--rs-font-family-featured-1: var(--rs-font-family-body);
--rs-letter-spacing-featured-1: normal;
--rs-font-size-featured-2: 1.5rem;
--rs-line-height-featured-2: 2rem;
--rs-font-family-featured-2: var(--rs-font-family-body);
--rs-letter-spacing-featured-2: normal;
--rs-font-size-featured-3: 1.25rem;
--rs-line-height-featured-3: 1.75rem;
--rs-font-family-featured-3: var(--rs-font-family-body);
--rs-letter-spacing-featured-3: normal;
--rs-font-size-body-1: 1.125rem;
--rs-line-height-body-1: 1.75rem;
--rs-font-family-body-1: var(--rs-font-family-body);
--rs-letter-spacing-body-1: normal;
--rs-font-size-body-2: 1rem;
--rs-line-height-body-2: 1.5rem;
--rs-font-family-body-2: var(--rs-font-family-body);
--rs-letter-spacing-body-2: normal;
--rs-font-size-body-3: 0.875rem;
--rs-line-height-body-3: 1.25rem;
--rs-font-family-body-3: var(--rs-font-family-body);
--rs-letter-spacing-body-3: normal;
--rs-font-size-caption-1: 0.75rem;
--rs-line-height-caption-1: 1rem;
--rs-font-family-caption-1: var(--rs-font-family-body);
--rs-letter-spacing-caption-1: normal;
--rs-font-size-caption-2: 0.625rem;
--rs-line-height-caption-2: 0.75rem;
--rs-font-family-caption-2: var(--rs-font-family-body);
--rs-letter-spacing-caption-2: normal;
--rs-unit-base: 4px;
--rs-unit-x1: 4px;
--rs-unit-x2: 8px;
--rs-unit-x3: 12px;
--rs-unit-x4: 16px;
--rs-unit-x5: 20px;
--rs-unit-x6: 24px;
--rs-unit-x7: 28px;
--rs-unit-x8: 32px;
--rs-unit-x9: 36px;
--rs-unit-x10: 40px;
--rs-radius-small: 4px;
--rs-radius-medium: 8px;
--rs-radius-large: 12px;
--rs-color-brand: #5a58f2;
--rs-color-white: #ffffff;
--rs-color-black: #000000;
--rs-color-on-background-primary: #ffffff;
--rs-color-on-background-critical: #ffffff;
--rs-color-on-background-warning: #000000;
--rs-color-on-background-positive: #ffffff;
--rs-color-on-brand: #ffffff;
--rs-color-rgb-white: 255, 255, 255;
--rs-color-rgb-black: 0, 0, 0;
--rs-duration-rapid: 100ms;
--rs-duration-fast: 200ms;
--rs-duration-medium: 300ms;
--rs-duration-slow: 400ms;
--rs-easing-standard: cubic-bezier(0.4, 0, 0.2, 1);
--rs-easing-accelerate: cubic-bezier(0.4, 0, 1, 1);
--rs-easing-decelerate: cubic-bezier(0, 0, 0.2, 1);
--rs-shadow-raised: 0px 1px 5px -4px rgba(0, 0, 0, 0.5), 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
--rs-shadow-overlay: 0px 5px 10px 0px rgba(0, 0, 0, 0.05), 0px 15px 25px 0px rgba(0, 0, 0, 0.07);
--rs-viewport-m-min: 660;
--rs-viewport-l-min: 900;
--rs-viewport-xl-min: 1280;
--rs-z-index-flyout: 4000;
			}
		
			[data-rs-theme="gintoTheme"][data-rs-color-mode="light"] {
					--rs-color-background-primary: #007B76;
--rs-color-background-primary-faded: #D0EDEB;
--rs-color-border-primary: #007B76;
--rs-color-border-primary-faded: #D0EDEB;
--rs-color-foreground-primary: #007B76;
--rs-color-background-critical: #E22C2C;
--rs-color-background-critical-faded: #FFF1EF;
--rs-color-border-critical: #C22022;
--rs-color-border-critical-faded: #f3dad6;
--rs-color-foreground-critical: #C22022;
--rs-color-background-warning: #FACC15;
--rs-color-background-warning-faded: #FFF6DD;
--rs-color-border-warning: #816802;
--rs-color-border-warning-faded: #ece2c4;
--rs-color-foreground-warning: #7B6305;
--rs-color-background-positive: #118850;
--rs-color-background-positive-faded: #EBFFF1;
--rs-color-border-positive: #0F7F4A;
--rs-color-border-positive-faded: #d2eddb;
--rs-color-foreground-positive: #0F7F4A;
--rs-color-background-neutral: #E3E4E8;
--rs-color-background-neutral-faded: #f3f3f5;
--rs-color-border-neutral: #0000001f;
--rs-color-border-neutral-faded: #00000014;
--rs-color-foreground-neutral: #2C2E34;
--rs-color-foreground-neutral-faded: #676A75;
--rs-color-background-disabled: #EDEEEF;
--rs-color-background-disabled-faded: #F6F6F7;
--rs-color-border-disabled: #E2E2E4;
--rs-color-foreground-disabled: #CBCCCF;
--rs-color-background-elevation-base: #FFFFFF;
--rs-color-background-elevation-raised: #FFFFFF;
--rs-color-background-elevation-overlay: #FFFFFF;
--rs-color-background-page: #FFFFFF;
--rs-color-background-page-faded: #FAFBFB;
--rs-color-brand-primary: #00A6A0;
--rs-color-rgb-background-primary: 0, 123, 118;
--rs-color-rgb-background-primary-faded: 208, 237, 235;
--rs-color-rgb-background-critical: 226, 44, 44;
--rs-color-rgb-background-critical-faded: 255, 241, 239;
--rs-color-rgb-background-warning: 250, 204, 21;
--rs-color-rgb-background-warning-faded: 255, 246, 221;
--rs-color-rgb-background-positive: 17, 136, 80;
--rs-color-rgb-background-positive-faded: 235, 255, 241;
--rs-color-on-background-neutral: #000000;
--rs-color-rgb-background-neutral: 227, 228, 232;
--rs-color-rgb-background-neutral-faded: 243, 243, 245;
--rs-color-rgb-background-disabled: 237, 238, 239;
--rs-color-rgb-background-disabled-faded: 246, 246, 247;
--rs-color-rgb-background-elevation-base: 255, 255, 255;
--rs-color-rgb-background-elevation-raised: 255, 255, 255;
--rs-color-rgb-background-elevation-overlay: 255, 255, 255;
--rs-color-rgb-background-page: 255, 255, 255;
--rs-color-rgb-background-page-faded: 250, 251, 251;
			}
		
			[data-rs-theme="gintoTheme"][data-rs-color-mode="dark"] {
					--rs-color-background-primary: #00736F;
--rs-color-background-primary-faded: #112A28;
--rs-color-border-primary: #3D9E99;
--rs-color-border-primary-faded: #1F4341;
--rs-color-foreground-primary: #3D9E99;
--rs-color-background-critical: #D72828;
--rs-color-background-critical-faded: #391B18;
--rs-color-border-critical: #E68075;
--rs-color-border-critical-faded: #5a2e29;
--rs-color-foreground-critical: #E68075;
--rs-color-background-warning: #D7AE06;
--rs-color-background-warning-faded: #2B2410;
--rs-color-border-warning: #EED58A;
--rs-color-border-warning-faded: #453c1e;
--rs-color-foreground-warning: #EED58A;
--rs-color-background-positive: #118850;
--rs-color-background-positive-faded: #152A1D;
--rs-color-border-positive: #57B17C;
--rs-color-border-positive-faded: #264431;
--rs-color-foreground-positive: #57B17C;
--rs-color-background-neutral: #393A42;
--rs-color-background-neutral-faded: #222835;
--rs-color-border-neutral: #ffffff24;
--rs-color-border-neutral-faded: #ffffff14;
--rs-color-foreground-neutral: #F3F3F5;
--rs-color-foreground-neutral-faded: #C7C9D1;
--rs-color-background-disabled: #242527;
--rs-color-background-disabled-faded: #1B1B1D;
--rs-color-border-disabled: #262729;
--rs-color-foreground-disabled: #494A4E;
--rs-color-background-elevation-base: #161617;
--rs-color-background-elevation-raised: #18191A;
--rs-color-background-elevation-overlay: #1D1D1F;
--rs-color-background-page: #0E0E0F;
--rs-color-background-page-faded: #131414;
--rs-color-brand-primary: #00A6A0;
--rs-color-rgb-background-primary: 0, 115, 111;
--rs-color-rgb-background-primary-faded: 17, 42, 40;
--rs-color-rgb-background-critical: 215, 40, 40;
--rs-color-rgb-background-critical-faded: 57, 27, 24;
--rs-color-rgb-background-warning: 215, 174, 6;
--rs-color-rgb-background-warning-faded: 43, 36, 16;
--rs-color-rgb-background-positive: 17, 136, 80;
--rs-color-rgb-background-positive-faded: 21, 42, 29;
--rs-color-on-background-neutral: #ffffff;
--rs-color-rgb-background-neutral: 57, 58, 66;
--rs-color-rgb-background-neutral-faded: 34, 40, 53;
--rs-color-rgb-background-disabled: 36, 37, 39;
--rs-color-rgb-background-disabled-faded: 27, 27, 29;
--rs-color-rgb-background-elevation-base: 22, 22, 23;
--rs-color-rgb-background-elevation-raised: 24, 25, 26;
--rs-color-rgb-background-elevation-overlay: 29, 29, 31;
--rs-color-rgb-background-page: 14, 14, 15;
--rs-color-rgb-background-page-faded: 19, 20, 20;
			}
